<mat-card>
  <mat-card-title>Licence</mat-card-title>

  <form>
    <mat-form-field>
      <mat-label>Select type</mat-label>
      <mat-select [(value)]="licence.type.id">
        <mat-option *ngFor="let type of licenceTypes" [value]="type.id"
          >{{ type.id + ' - ' + type.priceHuf + 'Ft' }}
        </mat-option>
      </mat-select> </mat-form-field
    ><br />
    <mat-form-field>
      <input
        matInput
        placeholder="Period from"
        type="text"
        [(ngModel)]="licence.startDate"
        [ngModelOptions]="{ standalone: true }"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <input
        matInput
        placeholder="Period to"
        type="text"
        [(ngModel)]="licence.endDate"
        [ngModelOptions]="{ standalone: true }"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <input
        matInput
        placeholder="Description"
        type="text"
        [(ngModel)]="licence.description"
        [ngModelOptions]="{ standalone: true }"
      /> </mat-form-field
    ><br />
    <button
      mat-button
      color="primary"
      class="button"
      type="button"
      (click)="toggle('licence.decision', true)"
    >
      decision: {{ licence.decision }}</button
    ><br />
    <button
      mat-button
      color="primary"
      class="button"
      type="button"
      (click)="toggle('licence.paid')"
    >
      paid: {{ licence.paid }}</button
    ><br />
    <mat-card-actions>
      <a mat-raised-button [routerLink]="['/accounts', accountPerma]"
        >Back to list</a
      >
      <div>
        <button
          mat-raised-button
          color="primary"
          class="button"
          type="button"
          (click)="submit()"
        >
          {{ isEdit ? 'Update' : 'Create' }}</button
        ><br />
        <button
          mat-raised-button
          color="warn"
          class="button"
          type="button"
          (click)="delete()"
        >
          Delete</button
        ><br />
      </div>
    </mat-card-actions>
  </form>

  <!-- <div class="licences">
            <table mat-table [dataSource]="licences" class="mat-elevation-z8">
                <ng-container matColumnDef="typeId">
                    <th mat-header-cell *matHeaderCellDef> Type ID </th>
                    <td mat-cell *matCellDef="let element"> {{element.typeId}} </td>
                </ng-container>
                <ng-container matColumnDef="period">
                    <th mat-header-cell *matHeaderCellDef> Period </th>
                    <td mat-cell *matCellDef="let element"> {{element.startdate | date:'yyyy-MM'}} -
                        {{element.enddate | date:'yyyy-MM'}} </td>
                </ng-container>
                <ng-container matColumnDef="permaId">
                    <th mat-header-cell *matHeaderCellDef> Perma ID </th>
                    <td mat-cell *matCellDef="let element"> {{element.permaId}} </td>
                </ng-container>
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                </ng-container>
                <ng-container matColumnDef="decision">
                    <th mat-header-cell *matHeaderCellDef> Decision </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon *ngIf="element.decision" style="color: green">check_circle</mat-icon>
                        <mat-icon *ngIf="element.decision == false" style="color: red">cancel</mat-icon>
                        <mat-icon *ngIf="element.decision == null">help</mat-icon>
                    </td>
                </ng-container>
                <ng-container matColumnDef="paid">
                    <th mat-header-cell *matHeaderCellDef> Paid </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon *ngIf="element.paid" style="color: green">check_circle</mat-icon>
                        <mat-icon *ngIf="element.paid == false" style="color: red">cancel</mat-icon>
                        <mat-icon *ngIf="element.paid == null">help</mat-icon>
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let element">
                        <a mat-raised-button [routerLink]="[ '/licences/'+element.permaId]">Edit</a>
                    </td>
                </ng-container>
    
                <tr mat-header-row *matHeaderRowDef="displayedLicenceColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedLicenceColumns;"></tr>
            </table>
        </div> -->
</mat-card>
